"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseClient = void 0;

class BaseClient {
  constructor(props) {
    this.headers = new Headers({
      'Authorization': `Bearer ${props.accessToken}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json; charset=utf-8'
    });
    this.channelIds = props.channelIds;
    this.cancelled = false;
  }
  /**
   * Mark the client as cancelled.
   */


  cancel() {
    this.cancelled = true;
  }
  /**
   * Return whether this client has been cancelled.
   */


  isCancelled() {
    return this.cancelled;
  }

}

exports.BaseClient = BaseClient;